const BLOCKED_DOMAINS = ["nullsto", "imail"];
const ALLOWED_TOP_LEVELS = ["edu", "ac"];

/**
 * Validates if email addrtess has an allowed top-level domain and is not blocked.
 * This is used to validate email addresses for EDU plan.
 *
 * @param {string} email
 * @returns {string|undefined} - Returns an error message if the domain is blocked or not allowed, otherwise undefined.
 */
module.exports = function validateEduDomains(email) {
    const domain = new URL("https://" + email.split("@").pop());
    const [topLevel, foreignTopLevel, name] = domain.hostname.split(".").reverse();

    if (topLevel === "ai" && foreignTopLevel === "beautiful") {
        // Allow beautiful.ai emails for testing
        return;
    }

    if (BLOCKED_DOMAINS.includes(name) || BLOCKED_DOMAINS.includes(foreignTopLevel)) {
        return "Email domain name is blocked.";
    }

    // Check if domain contains allowed educational domains in the correct position
    // Allow .edu, .ac as TLD OR as second-level domain (e.g., .edu.au, .ac.uk)
    // But prevent bypasses like .edu.com where edu/ac is followed by commercial domains
    const domainParts = domain.hostname.split(".");
    const hasValidEduDomain = ALLOWED_TOP_LEVELS.some(allowedDomain => {
        const index = domainParts.indexOf(allowedDomain);
        if (index === -1) return false;

        // If it's the TLD (last part), it's valid
        if (index === domainParts.length - 1) return true;

        // If it's second-to-last and followed by a valid country code (2-3 letters), it's valid
        // Common country codes: au, uk, nz, ca, etc. Exclude common commercial TLDs that aren't country codes
        if (index === domainParts.length - 2) {
            const possibleCountryCode = domainParts[index + 1];
            const commercialTlds = ["com", "net", "biz", "info", "name", "pro"];
            return possibleCountryCode.length >= 2 && possibleCountryCode.length <= 3 &&
                   /^[a-z]+$/i.test(possibleCountryCode) &&
                   !commercialTlds.includes(possibleCountryCode.toLowerCase());
        }

        return false;
    });

    if (!hasValidEduDomain) {
        return "Email must have an edu/ac top-level domain.";
    }
};
